import chroma from "chroma-js";

export const LIGHT_GREY = chroma("#ececec");
export const TURQUOISE = chroma("#9fd3c7");
export const DARK_BLUE = chroma("#385170");
export const DARKER_BLUE = chroma("#142d4c");
